// extracted by mini-css-extract-plugin
module.exports = {"StarsBar":"StarsBar_StarsBar__ltcoY","bigFont":"StarsBar_bigFont__DzufT"};